import { render, staticRenderFns } from "./top-search.vue?vue&type=template&id=0baa3b86&"
import script from "./top-search.vue?vue&type=script&lang=js&"
export * from "./top-search.vue?vue&type=script&lang=js&"
import style0 from "./top-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports